/**
 * Clés ayant servi, à un moment ou un autre, à stocker la liste d'invités.
 * Aucune ne doit plus jamais atteindre poll_data_json : ce champ est renvoyé
 * aux visiteurs (get_poll_by_slug) et lisible en SELECT direct pour les
 * sondages publiés. La liste vit désormais dans public.poll_invitations.
 */
const EMAIL_LIST_KEYS = [
  "participantEmails",
  "invitedEmails",
  "emailForCopy",
  "inviteEmails",
] as const;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Rassemble les adresses saisies, quel que soit le champ d'origine. */
export function collectInviteEmails(pollData: {
  settings?: Record<string, any>;
  participantEmails?: string[];
  invitedEmails?: string[];
}): string[] {
  const raw: unknown[] = [];
  const push = (v: unknown) => {
    if (Array.isArray(v)) raw.push(...v);
    else if (typeof v === "string") raw.push(...v.split(/[,;\s]+/));
  };
  push(pollData.participantEmails);
  push(pollData.invitedEmails);
  for (const key of EMAIL_LIST_KEYS) push(pollData.settings?.[key]);

  const seen = new Set<string>();
  for (const v of raw) {
    if (typeof v !== "string") continue;
    const email = v.trim().toLowerCase();
    if (email && EMAIL_RE.test(email)) seen.add(email);
  }
  return [...seen];
}

/** Retire toute adresse des settings avant persistance. */
export function stripEmailFields(
  settings?: Record<string, any>,
): Record<string, any> | undefined {
  if (!settings) return settings;
  const out = { ...settings };
  for (const key of EMAIL_LIST_KEYS) delete out[key];
  return out;
}
